import { SECTIONIDS } from "../../../constants/sectionId";

export default function FooterSection() {
  return (
    <footer className="relative bg-black pt-32 backdrop-opacity-0">
      <div className="mx-auto max-w-7xl px-6 pb-12 lg:px-12 xl:px-6 2xl:px-0">
        <div className="mt-12 md:mt-16 lg:mt-24">
          <div className="space-y-8 md:space-y-12">
            <a
              href={`/#${SECTIONIDS.HERO}`}
              className="text-2xl font-light tracking-widest text-white"
            >
              EROM STUDIO
            </a>
            <nav>
              <ul className="flex flex-wrap gap-6 text-sm uppercase tracking-wider text-white">
                <li>
                  <a href={`#${SECTIONIDS.HERO}`}>Home</a>
                </li>
                <li>
                  <a href={`#${SECTIONIDS.WORK}`}>Work</a>
                </li>
                <li>
                  <a href={`#${SECTIONIDS.SERVICES}`}>Services</a>
                </li>
                <li>
                  <a className="block w-max" href={`#${SECTIONIDS.ABOUT}`}>
                    About us
                  </a>
                </li>
                <li>
                  <a href={`#${SECTIONIDS.CONTACT}`}>Contact</a>
                </li>
              </ul>
            </nav>
            <div className="flex flex-wrap justify-between gap-3">
              <span className="text-sm text-white/50">
                © Erom Studio 2024 - Present
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
